import React, { useState } from 'react';

const ThreeWayToggle = ({ initialMode, onChange }) => {
  //console.log('toggle view:', initialMode);
  if (initialMode === undefined) {
    initialMode = 'table';
  }
  const [activeMode, setActiveMode] = useState(initialMode);

  const handleModeChange = (mode) => {
    setActiveMode(mode);
    if (onChange) {
      onChange(mode);
    }
  };

  const iconStyle = {
    width: '20px',
    height: '20px'
  };

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px'
  };

  const buttonStyle = (mode) => ({
    cursor: 'pointer',
    padding: '10px',
    border: activeMode === mode ? '2px solid blue' : '2px solid transparent',
    borderRadius: '5px',
    transition: 'border 0.3s'
  });

  return (
    <div style={containerStyle}>
      {/* Table Mode */}
      <div
        style={buttonStyle('table')}
        onClick={() => handleModeChange('table')}
      >
        <svg
          style={iconStyle}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <line x1="3" y1="9" x2="21" y2="9" />
          <line x1="3" y1="15" x2="21" y2="15" />
          <line x1="9" y1="3" x2="9" y2="21" />
          <line x1="15" y1="3" x2="15" y2="21" />
        </svg>
      </div>

      {/* Gallery Mode */}
      <div
        style={buttonStyle('gallery')}
        onClick={() => handleModeChange('gallery')}
      >
        <svg
          style={iconStyle}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
        </svg>
      </div>

      {/*
      <div
        style={buttonStyle('dock')}
        onClick={() => handleModeChange('dock')}
      >
        <svg
          style={iconStyle}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="3" width="18" height="4" />
          <rect x="3" y="10" width="18" height="4" />
          <rect x="3" y="17" width="18" height="4" />
        </svg>
      </div>Dock Mode */}
    </div> 
  );
};

export default ThreeWayToggle;
